import { render } from "./UserAcceptList.vue?vue&type=template&id=c418041e&scoped=true"
import script from "./UserAcceptList.vue?vue&type=script&lang=js"
export * from "./UserAcceptList.vue?vue&type=script&lang=js"

import "./UserAcceptList.vue?vue&type=style&index=0&id=c418041e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c418041e"]])

export default __exports__